type Props = {
  children: React.ReactNode
  /**
   * Optional alert/info content rendered above the step body
   * (e.g. the EV step's "Set your daily Ready By time…" reminder).
   */
  alertSlot?: React.ReactNode
}

/**
 * Shared layout shell for each post-enrollment configuration step.
 *
 * `ConfigureDevicesRoot.tsx` already renders the navigation header, footer
 * (Continue button + helper alert), and progress bar — this component renders
 * only the step body content stacked vertically with a consistent gap.
 *
 * Centralizing this prevents the three step PRs (DEV-6022/6023/6024) from
 * drifting on padding/gap tokens.
 */
export default function ConfigureDeviceStepBody({
  children,
  alertSlot,
}: Props) {
  return (
    <div className="flex flex-col gap-4">
      {alertSlot}
      {children}
    </div>
  )
}
